import React from 'react';
import '../../../../assets/scss/components/videoVerification/VideoPlayerIpv.scss'
import OtpTimer from '../../../generic/OtpTimer';
import Button from './Button';

//import { isSafariBrowser } from '../../Services/globalService';
import browserName from '../../../utils/browserName';
import EdButton from '../../../generic/edButton';

export interface VideoPlayerIpvProps {
    ipvUploaded: (uploadObj: any) => any
    isGeoError?: boolean;
}

export function captureScreenShot(video: HTMLVideoElement, callback: CallableFunction) {
    let canvas: HTMLCanvasElement = document.createElement('canvas') as HTMLCanvasElement;
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext('2d')!.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
    canvas.toBlob((blob) => {
        const new_File = new File([blob as BlobPart], 'safariVideoIPV.webm', { type: 'video/webm', lastModified: Date.now() });
        const fileReader = new FileReader();
        fileReader.onload = function (e) {
            const base64 = (e.target && e.target.result)?.toString();
            callback(base64?.split(',')[1], blob, video.videoWidth, video.videoHeight);
        }
        fileReader.readAsDataURL(new_File);
    });
}

export function recordVideoFromStream(
    stream: MediaStream,
    durationMs: number
): Promise<Blob> {
    return new Promise((resolve, reject) => {
        const recorder = new MediaRecorder(stream, { mimeType: 'video/mp4' });
        const chunks: BlobPart[] = [];
        recorder.ondataavailable = (e) => chunks.push(e.data);
        recorder.onstop = () => {
            const blob = new Blob(chunks, { type: 'video/webm' });
            resolve(blob);
        };
        
        recorder.onerror = reject;
        recorder.start();
        setTimeout(() => recorder.stop(), durationMs);
    });
}
export function blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve((reader.result as string).split(',')[1]);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
}

const VideoPlayerIpv: React.FC<VideoPlayerIpvProps> = (props) => {

    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [showStartBtn, setShowStartBtn] = React.useState<boolean>(true);
    const [showVidPerm, setShowVidPerm] = React.useState<boolean>(false);
    const [showRecordTimer, setShowRecordTimer] = React.useState<boolean>(false);
    const [showUploadBtn, setShowUploadBtn] = React.useState<boolean>(false);
    const [stream, setStream] = React.useState<MediaStream>();
    const [webBlob, setWebBlob] = React.useState<Blob>();
    const [frames, setFrames] = React.useState<Array<any>>([]);
    const [mediaRecorder, setMediaRecorder] = React.useState<MediaRecorder>();
    const videoRefElement = React.useRef<HTMLVideoElement>(null);
    const previewRefElement = React.useRef<HTMLVideoElement>(null);
    const imageRefElement = React.useRef<HTMLImageElement>(null);
    const [imgSrcSafari, setImgSrcSafari] = React.useState<string>();
    const [videoWidth, setVideoWidth] = React.useState<number>();
    const [videoHeight, setVideoHeight] = React.useState<number>();
    const [videoData, setVideoData] = React.useState<string>();

    React.useEffect(() => {
        turnOnCamera();
        showPreview(false);
        return () => {
        }
    }, []);

    React.useEffect(() => {
        return () => {
            stream && stream.getVideoTracks()[0].stop();
        }
    }, [stream])

    function showPreview(showPreview: boolean) {
        videoRefElement.current!.hidden = showPreview;
        if (browserName().browserName === "Safari" || window.localStorage.getItem("lgnSrc") === "iphone")
            imageRefElement.current!.hidden = !showPreview;
        else
            previewRefElement.current!.hidden = !showPreview;
    }

    function turnOnCamera() {
        setIsLoading(true);

        const constraints = {
            audio: false,
            video: {
                facingMode: 'user'
            }
        };

        function handleSuccess(stream: MediaStream) {
            videoRefElement.current!.srcObject = stream;
            try {
                setMediaRecorder(new MediaRecorder(stream));
            } catch (ex) { }
            setStream(stream)
            setShowVidPerm(false);
            setIsLoading(false);
        }

        function handleError(error: any) {
            setShowVidPerm(true);
            setIsLoading(false);
        }

        navigator.mediaDevices.getUserMedia(constraints)
            .then(handleSuccess)
            .catch(handleError);
    }

    function record() {
        setShowStartBtn(false);
        setShowRecordTimer(true);
        let interval: NodeJS.Timeout;
        const arr: Array<string> = [];
        if (browserName().browserName === 'Safari' || window.localStorage.getItem("lgnSrc") === "iphone") {
            interval = setInterval(() =>
                // captureScreenShot(videoRefElement.current!, (base64: string, blob: Blob, videoWidth: number, videoHeight: number) => {
                //     setImgSrcSafari(window.URL.createObjectURL(blob));
                //     setVideoWidth(videoWidth);
                //     setVideoHeight(videoHeight);
                //     arr.push(base64);
                // })
                {
                            navigator.mediaDevices.getUserMedia({ video: true}).then(async (stream) => {
                                const videoBlob = await recordVideoFromStream(stream, 5000); // record 3 seconds
                                //const url = URL.createObjectURL(videoBlob);
                                return videoBlob
                            }).then(async (blob) => {
                                //setImgSrcSafari(window.URL.createObjectURL(blob));
                                const base64 = await blobToBase64(blob)
                                return base64;
                            }).then(async (base64) => {
                                setVideoData(base64)
                                arr.push(base64);
                            });
                            
                        }
                , 500);
        } else {
            mediaRecorder && mediaRecorder.start();
        }
        setTimeout(() => {
            setShowRecordTimer(false);
            setShowUploadBtn(true);
            (browserName().browserName  === 'Safari'  || window.localStorage.getItem("lgnSrc") === "iphone" ) && interval && clearInterval(interval);
            stop(arr);
        }, 5100);
    }

    if (mediaRecorder) {
        mediaRecorder.ondataavailable = function (event: any) {
            setFrames([event.data]);
        }

        mediaRecorder.onstop = (ev: any) => {
            const blob = new Blob(frames, { 'type': 'video/webm' });
            previewRefElement.current!.src = window.URL.createObjectURL(blob);
            setWebBlob(blob);
            showPreview(true);
        }
    }

    function stop(framesArr?: Array<string>) {
        showPreview(true);
        if (browserName().browserName && framesArr) {
            setFrames(framesArr);
        } else {
            mediaRecorder && mediaRecorder.stop();
        }
        stream && stream.getVideoTracks()[0].stop();
    }

    const retryVideo = () => {
        setFrames([]);
        showPreview(false);
        setShowUploadBtn(false);
        setShowRecordTimer(false);
        setShowStartBtn(true);
        setImgSrcSafari('');
        turnOnCamera();
    }

    function uploadVideo() {
        if(browserName().browserName  === 'Safari' || window.localStorage.getItem("lgnSrc") === "iphone" ) {
            console.log(frames)
            props.ipvUploaded(videoData)
          }
          else {
            const new_File = new File([webBlob as BlobPart], 'videoIPV.webm', { type: 'video/webm', lastModified: Date.now() });
            if (new_File.size > 50000000) {
                alert('video size exceeds maximum limit. Please upload it again');
                return false;
            }
            const fileReader = new FileReader();
            fileReader.onload = function (e) {
                const base64 = (e.target && e.target.result)?.toString();
                if (base64?.toString()) {
                    props.ipvUploaded(base64!.split(',')[1]);
                    //console.log("videofile",base64!.split(',')[1])
                }
            }
            fileReader.readAsDataURL(new_File);
          }
        }
    

    return (
        <div className='videoPlayerIpv'>
            {
                showVidPerm &&
                <div className='videoPermission'>
                    <label className='videoPermissionMsg'>Please allow access for camera from the advance setting to complete this step.</label>
                </div>
            }
            <video
                className='videoPlayer'
                id='videoRef'
                ref={videoRefElement}
                autoPlay
                playsInline
            />
            { 
                (browserName().browserName === 'Safari' || window.localStorage.getItem("lgnSrc") === "iphone") ?
                    <img 
                        // src={imgSrcSafari}
                        ref={imageRefElement}
                        alt='Preview is not available! Please upload and proceed'
                        className='videoPlayer'
                    />
                    :
                    <video
                        className='videoPlayer'
                        ref={previewRefElement}
                        controls
                        controlsList="nodownload nofullscreen noremoteplayback"
                    />
            }

            {/* Start Recording Button Start */}
            {
                showStartBtn && !props.isGeoError && (
                <div className={'startBtn' + (isLoading || showVidPerm ? ' op05' : '')}
                    onClick={(isLoading || showVidPerm) ? () => { } : () => record()}
                >
                    <span className='edel-icon-video' />
                    <label className='startLbl'>Start Recording</label>
                </div>
                )}
            {/* Start Recording Button End */}

            {/* Recording Timer Start */}
            {
                showRecordTimer &&
                <div className='recordingTimer'>
                    <OtpTimer timer={5} />
                </div>
            }
            {/* Recording Timer End */}

            {/* Upload Btn Start */}
            {
                showUploadBtn &&
                <div className='uploadDiv'>
                    <label className='uploadInfo'>Make sure the quality of the video is clear and the OTP and your face is clearly visible.</label>
                    <div className='uploadBtns'>
                       {/* <Button
                            btnName='Retry'
                            isSecondary={true}
                            onClick={retryVideo}
                        />
                        <Button
                            btnName='Upload'
                            disabled={false}
                            isLoading={false}
                            onClick={uploadVideo}
                        /> */}
                        <div className={'startBtn' + (isLoading || showVidPerm ? ' op05' : '')} onClick={retryVideo}>
                        <label className='startLbl'>Retry</label>
                        </div>
                        <div className={'startBtn' + (isLoading || showVidPerm ? ' op05' : '')} onClick={uploadVideo}>
                        <label className='startLbl'>Upload & Proceed</label>
                        </div>
                    </div>
                </div>
            }
            {/* Upload Btn End */}
        </div>
    );
}

export default VideoPlayerIpv;